<p-dialog [(visible)]="sidebarVisible" position="right" (onHide)="closeDrawer()" [draggable]="false" [resizable]="false"
    [modal]="true" [dismissableMask]="true" class="drawer-notification">

    <ng-template pTemplate="header">
        <span>
            {{ 'home.widgetInfo.notification.drawer.title' | translate }}
            <p-badge severity="danger" [value]="publications.length"></p-badge>
        </span>
    </ng-template>

    <div class="d-flex flex-row justify-content-between">
        <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button" id="sortDropdown" data-toggle="dropdown"
                aria-expanded="false">
                {{ 'home.widgetInfo.notification.drawer.sort.title' | translate }}
            </button>
            <div class="dropdown-menu" aria-labelledby="sortDropdown">
                <button class="dropdown-item" [class.active]="currentSort.field==='date' && currentSort.order==='asc'"
                    (click)="sort('date', 'asc')">{{ 'home.widgetInfo.notification.drawer.sort.dateAsc' | translate }}</button>

                <button class="dropdown-item" [class.active]="currentSort.field==='date' && currentSort.order==='desc'"
                    (click)="sort('date', 'desc')">{{ 'home.widgetInfo.notification.drawer.sort.dateDesc' | translate }}</button>

                <button class="dropdown-item" [class.active]="currentSort.field==='clubName' && currentSort.order==='asc'"
                    (click)="sort('clubName', 'asc')">{{ 'home.widgetInfo.notification.drawer.sort.clubAsc' | translate }}</button>

                <button class="dropdown-item" [class.active]="currentSort.field==='clubName' && currentSort.order==='desc'"
                    (click)="sort('clubName', 'desc')">{{ 'home.widgetInfo.notification.drawer.sort.clubDesc' | translate }}</button>
            </div>
        </div>

        <button class="btn btn-secondary" type="button" (click)="readAll()">
            {{ 'home.widgetInfo.notification.drawer.readAll' | translate }}
        </button>
    </div>

    <div class="d-flex flex-column drawer-notification-main">
        <!-- Loading indicator -->
        <div *ngIf="isLoadingPublications" class="text-center p-4">
            <wudo-spinner></wudo-spinner>
        </div>

        <!-- Publications list -->
        <div *ngFor="let pub of publications" class="item d-flex flex-column" role="listitem">
            <app-drawer-notification-post [publicationId]="pub.id" [lastVisitDate]="dateNow"
                (seeMoreSignal)="onSeeMore($event)" [publicationClubAndRoomName]="getClubAndRoom(pub.id)"
                [isFromHomeDrawer]="true"></app-drawer-notification-post>
        </div>
    </div>
</p-dialog>

<!-- 2ND DRAWER -> FOCUS ON A SINGLE PUBLICATION -->
<p-dialog [(visible)]="focusedPublicationDrawer" position="right" [draggable]="false"
    (onHide)="closeFocusedPublicationDrawer()" [resizable]="false" [modal]="true" [dismissableMask]="true"
    class="drawer-notification second-drawer">
    <ng-template pTemplate="header">
        <button (click)="closeFocusedPublicationDrawer()" class="btn btn-light">
            <i class="pi pi-arrow-left"></i>
            <span>{{ 'home.widgetInfo.notification.drawer.back' | translate }}</span>
        </button>

        <a tabindex="0" (click)="goToPublicationPage(focusedPublication.clubId, focusedPublication.id)"
            class="btn btn-light">{{ 'home.widgetInfo.notification.drawer.seePublication' | translate }}
        </a>
    </ng-template>

    <app-publication-card *ngIf="focusedPublication" [initOnCommentField]="initOnCommentField"
        [publicationId]="focusedPublication.id" [lastVisitDate]="dateNow" [isFromHomeDrawer]="true" class="drawer-notification-main">
    </app-publication-card>
</p-dialog>
